import React from 'react';
import { Box, styled } from '@mui/material';
import pallet from '../../../layouts/pallet';

interface StatusLabelProps {
  status: 'ACTIVE' | 'IN_ACTIVE' | string;
  label?: string;
}

const StatusContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== '$isActive'
})<{ $isActive: boolean }>(({ $isActive }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  width: 'fit-content',
  minWidth: '64px',
  height: '24px',
  padding: '4px 8px',
  borderRadius: '6px',
  backgroundColor: $isActive ? pallet.lightGreen : pallet.lightRed,
  color: $isActive ? pallet.green2 : pallet.red2,
  fontSize: '13px',
  fontWeight: 500,
  opacity: 1
}));

const StatusDot = styled('span', {
  shouldForwardProp: (prop) => prop !== '$isActive'
})<{ $isActive: boolean }>(({ $isActive }) => ({
  width: '6px',
  height: '6px',
  borderRadius: '50%',
  backgroundColor: $isActive ? pallet.green2 : pallet.red2
}));

const StatusLabel: React.FC<StatusLabelProps> = ({ status, label }) => {
  const isActive = status === 'ACTIVE';
  const displayLabel = label || (isActive ? 'Active' : 'Inactive');

  return (
    <StatusContainer $isActive={isActive}>
      <StatusDot $isActive={isActive} />
      {displayLabel}
    </StatusContainer>
  );
};

export default StatusLabel;
